import React from 'react';
import { ISmartProps } from './types';

import { SidebarItemProps as _SidebarItemProps } from './types';
import { SidebarGroupProps as _SidebarGroupProps } from './types';
import { CustomSidebar, SidebarItem as _SidebarItem, SidebarGroup as _SidebarGroup , SidebarMultiItem as _SidebarMultiItem } from './view';

export type SidebarItemProps = _SidebarItemProps;
export type SidebarGroupProps = _SidebarGroupProps;

export type SideBarProps = Omit<ISmartProps, 'css'>;

export const Sidebar = CustomSidebar;
export const SideBar = CustomSidebar;
export const SidebarItem = _SidebarItem;
export const SidebarMultiItem = _SidebarMultiItem;
export const SidebarGroup = _SidebarGroup;
